import { useEffect } from 'react';

import { Helpers } from '../../../../utility/helpers';
import useModal from '../../../common/hooks/useModal';
import { PriceType } from '../../../common/models/priceData/priceData';
import type { ProductProps } from '../../../common/models/props/itemTeaserProps';
import { FlyInType } from '../../../common/store/structureDefinitions/modalState';
import ga4SustainabilityEvents from '../../../common/tracking/ga4/sustainability/ga4SustainabilityEvents';
import gaTracking from '../../../common/tracking/tracking';
import SustainabilityButton from './SustainabilityButton';
import SustainabilityFlyinModal from './SustainabilityFlyinModal';

export interface SustainabilityDeclarationButtonProps {
    product: ProductProps;
    className?: string;
}

const SustainabilityDeclarationButton = (props: SustainabilityDeclarationButtonProps) => {
    const { open, isOpen } = useModal(FlyInType.SustainabilityDeclaration);

    const handleClick = () => {
        ga4SustainabilityEvents.view();
        open();
    };

    useEffect(() => {
        if (isOpen) {
            const { manufacturer, name, priceData } = props.product;
            gaTracking.ecommerce.sustainability.open({
                ean: props.product.identifier,
                manufacturer,
                name,
                price: priceData && Helpers.getPrice(priceData, PriceType.IncludeTax),
            });
        }
    }, [isOpen, props.product]);

    if (!props.product.sustainabilityInfoApplicable) {
        return null;
    }

    return (
        <>
            <SustainabilityButton
                className={props.className}
                sustainabilityInfo={props.product.sustainabilityInfo}
                handleClick={handleClick}
            />
            <SustainabilityFlyinModal
                ean={props.product.identifier}
                missingData={!props.product.sustainabilityInfo}
            />
        </>
    );
};

export default SustainabilityDeclarationButton;
